// Quem pode criar/ativar/desativar. Fonte única da regra — a UI só esconde; o
// gateway valida de novo.
import { FRONTEND_ROUTES } from "@/constants"
import { usePermission } from "@/contexts/permission"

const WRITE_ROLES = [
  ...FRONTEND_ROUTES.PAYMENT_CONFIGURATIONS_CREATE
    .permissionRoles,
]

export const useCanWritePaymentConfigurations = () => {
  const { hasPermission } = usePermission()
  return hasPermission(WRITE_ROLES)
}
